module.exports = __webpack_public_path__ + "static/media/overwatch.99633f89.jpg";